import React, { useState } from "react";
import axios from "axios";
import CustomerNavbar from "../../../components/CustomerNavar/CustomerNavbar";
import images1 from "../../../images/Carrymypet-01.png";
import loginscreen from "../../../images/LoginScreen.png";
import "./LoginCustomer.css";

const LoginCustomer = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [step, setStep] = useState(1); // Step 1: Enter email, Step 2: Enter password or create new password

  const baseAPI = process.env.REACT_APP_API_URL;

  const handleSubmitEmail = async (e) => {
    e.preventDefault();
    try {
      // Check if email exists in the database
      const response = await axios.post(
      `${baseAPI}/customer/checkEmail`,
        { email }
      );
      if (response.data.status === "True") {
        // Email exists, check if password exists
        if (response.data.hasPassword) {
          // Password exists, proceed to next step
          setStep(2);
        } else {
          // Password doesn't exist, proceed to create new password
          setStep(3);
        }
      } else {
        // Email does not exist
        alert("Email not found in the database");
      }
    } catch (error) {
      console.error("Error checking email:", error);
      alert("Error checking email");
    }
  };

  const handleSubmitPassword = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${baseAPI}customer/customerLogin`,
        { email, password }
      );

      if (response.data.status === "True") {   
        // Check if Data and access_token exist in the response
        if (response.data.Data && response.data.Data.access_token) {         
          // Save the access token to the local storage
          localStorage.setItem('accessToken', JSON.stringify(response.data.Data.access_token));
          window.location.href = "/Order-Data";
        } else {
          alert("Access token not found in the response.");
        }
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error submitting password");
    }
  };

  const handleCreatePassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    try {
      const response = await axios.post(
        `${baseAPI}customer/createPassword`,
        { email, password: newPassword }
      );
      if (response.data.status === "True") {
        alert(
          "Password created successfully. Please login with your new password."
        );
        setStep(2);
      } else {
        alert("Failed to create password");
      }
    } catch (error) {
      console.error("Error creating password:", error);
      alert("Error creating password");
    }
  };

  return (
    <div>
      <CustomerNavbar />
      {step === 1 && (
        <div className="container">
          <div className="imgContainer">
            <img src={loginscreen} className="image" alt="Login Screen" />
          </div>
          <div className="formContainer">
            <form onSubmit={handleSubmitEmail} className="form">
              <img alt="Loading..." src={images1} className="formImage" />
              <div className="formGroup">
                <h4 className="text">Log In</h4>
                <span className="text">Customer ID</span>
                <input
                  type="email"
                  className="formControl"
                  placeholder="Enter"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="buttonContainer">
                <button type="submit" className="button">
                  Next
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="container">
          <div className="imgContainer">
            <img src={loginscreen} className="image" alt="Login Screen" />
          </div>
          <div className="formContainer">
            <form onSubmit={handleSubmitPassword} className="form">
              <img alt="Loading..." src={images1} className="formImage" />
              <div className="formGroup">
                <h4 className="text">Log In</h4>
                <span className="text">Password</span>
                <input
                  type="password"
                  className="formControl"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className="buttonContainer">
                <button type="submit" className="button">
                  Log In
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {step === 3 && (
        <div className="container">
          <div className="imgContainer">
            <img src={loginscreen} className="image" alt="Login Screen" />
          </div>
          <div className="formContainer">
            <form onSubmit={handleCreatePassword} className="form">
              <img alt="Loading..." src={images1} className="formImage" />
              <div className="formGroup">
                <h4 className="text"> Log In</h4>
                <span className="text">Create Password</span>
                <input
                  type="password"
                  className="formControl"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
                <input
                  type="password"
                  className="formControl"
                  placeholder="Re-enter new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
              <div className="buttonContainer">
                <button type="submit" className="button">
                  Create Password
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginCustomer;
